import api from '@app/application/document/screens/move-modal/api/index'

onDomLoad(function ($dom) {
  $dom.find("[data-target='move-document-modal']").each(function () {
    this.onclick = (event) => {
      event.preventDefault()
      event.stopPropagation()

      api.navigateTo(this.href).then((response) => {
        window.modalCitizen.openModal('move-document-modal', response)
      })
    }
  })
})
